import {
  Rotationsplan_ArbeitsbereicheByStandortIdsQuery,
  Rotationsplan_ArbeitsbereicheByStandortIdsQueryVariables,
} from '@/gql/graphql';
import { useSuspenseQuery } from '@apollo/client/react';
import * as Sentry from '@sentry/react';
import { ARBEITSBEREICHE_BY_STANDORT_IDS } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useArbeitsbereicheOptions/graphql/queries';
import { ArbeitsbereichOption } from '@/domain/mitarbeiter/features/rotationsplan/entities/ArbeitsbereichOption';

export function useArbeitsbereicheOptions(standortIds: string[]): {
  arbeitsbereiche: ArbeitsbereichOption[];
  error?: string;
} {
  const result = useSuspenseQuery<
    Rotationsplan_ArbeitsbereicheByStandortIdsQuery,
    Rotationsplan_ArbeitsbereicheByStandortIdsQueryVariables
  >(ARBEITSBEREICHE_BY_STANDORT_IDS, {
    variables: { standortIds },
  });

  if (result.error) {
    Sentry.captureException(result.error);
    return { arbeitsbereiche: [] };
  }

  return {
    arbeitsbereiche: result.data.mitarbeiter_arbeitsbereicheByStandortIds.map(
      (arbeitsbereich) =>
        new ArbeitsbereichOption({
          id: arbeitsbereich.id,
          name: arbeitsbereich.name,
          markierung: arbeitsbereich.markierung,
        }),
    ),
  };
}
